module.exports = __webpack_public_path__ + "static/media/white-check.4e5c0a3d.svg";